import login from './login.vue';
import passwordRequest from './password-request.vue';
import passwordReset from './password-reset.vue';
import signup from './signup.vue';
import verify from './verify.vue';

export default { login, passwordRequest, passwordReset, signup, verify };
